import { apiSend, getRoute } from "@services/axios";
import { Suspense, lazy } from "react";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import Loader from "@components/Loader";
import LoadError from "@components/LoadError";
const queryClient = new QueryClient();

const Details = ({ bookingNumber }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LoadDetails bookingNumber={bookingNumber} />
    </QueryClientProvider>
  );
};

export default Details;

function LoadDetails({ bookingNumber }) {
  const { isLoading, error, data } = useQuery("repoData", () =>
    apiSend([getRoute("BOOKING_RETRIEVE"), bookingNumber].join("/"), "get")
  );
  if (isLoading) return <Loader />;
  if (error) return <LoadError message="booking not found" />;

  const service = data.data.result.bookingType;
  const fielName =
    "Details" + service.charAt(0).toUpperCase() + service.slice(1);
  const ComponentDetail = lazy(() => import(`./components/${fielName}`));

  return <Suspense>{<ComponentDetail booking={data.data.result} />}</Suspense>;
}
